import { apiPost } from './api';

/**
 * Procesa un pago con Flow
 * @param {object} params
 * @param {string} params.orderId - ID o número del pedido (ej: numero_pedido)
 * @param {number} params.amount - Monto total en CLP
 * @param {string} [params.email] - Email del cliente (opcional si viene del JWT)
 * @param {string} [params.subject] - Asunto del pago
 * @param {string} [params.returnUrl] - URL de retorno tras pago exitoso
 * @param {string} [params.cancelUrl] - URL si el usuario cancela
 * @param {string} [params.currency] - Moneda (default CLP)
 * @returns {Promise<{payment_url: string, payment_id: string}>}
 */
export const processFlowPayment = async ({
  orderId,
  amount,
  email,
  subject,
  returnUrl,
  cancelUrl,
  currency = 'CLP'
}) => {
  const baseUrl = window.location.origin;
  const response = await apiPost('/api/pagos/process', {
    order_id: orderId,
    payment_method: 'flow',
    amount: Number(amount),
    currency: currency || 'CLP',
    payment_data: {
      email: email || undefined,
      subject: subject || `Pedido ${orderId}`,
      return_url: returnUrl || `${baseUrl}/pago-exitoso`,
      cancel_url: cancelUrl || `${baseUrl}/pago-cancelado`
    }
  });

  const data = await response.json();

  if (!data.success) {
    throw new Error(data.error || 'Error al procesar el pago');
  }

  if (!data.payment_url) {
    throw new Error('No se recibió la URL de pago de Flow');
  }

  return {
    payment_url: data.payment_url,
    payment_id: data.payment_id || data.transaction?.payment_id
  };
};

export default { processFlowPayment };
